import styled from 'styled-components'

export default styled.article`
  display: flex;
  height: 100%;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;
  
  .text-container {
    width: 100%;
    max-width: 515px;
    border-radius: 20px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    padding: 70px 80px;
    box-sizing: border-box;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    background-color: ${ ({ theme }) => theme.colors.white };  
    display: flex;
    flex-direction: column;
    gap: 16px;

    .title {
      text-align: center;
      font-size: 28px;
      line-height: normal;
      font-weight: bold;
      margin-bottom: 10%;
    }

    .subtitle {
      font-size: 20px;
      line-height: normal;
      text-align: center;
      white-space: break-spaces;
      a {
        margin-top: 16px;
        margin-left: 8px;
        color: ${ ({ theme }) => theme.colors.blueLight };
        font-weight: bold;
      }
    }

    .reminder {
      font-size: 16px;
      line-height: normal;
      text-align: center;
      color: ${ ({ theme }) => theme.colors.greyMedium };
    }
  }

  @media screen and (max-width: 768px) {
    .text-container {
      padding: 40px 24px;
    }

    .text-container .title {
      font-size: 24px;
    }

    .text-container .subtitle {
      font-size: 18px;
    }
  }
`